<div fxLayout="column">
    <ng-container *ngIf="formGroup">
        <form [formGroup]="formGroup" class="settings w-100-p"
              fxFlex fxLayout="column" data-test="C-UI-Einstellungen">

            <div class="fuse-card auto-width">

                <div class="p-16"
                     fxLayout="column" fxLayoutAlign="center stretch"
                     fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

                    <div fxLayout="row" fxLayoutAlign="start center">

                        <div fxLayout="column" fxLayoutAlign="start start">
                            <div class="h2">
                                {{ 'settings.uiSettings.title' | translate }}
                            </div>
                        </div>

                    </div>

                    <ng-template #saving>
                        <mat-icon>save</mat-icon>
                        <span>{{ 'common.saving' | translate }}</span>
                        <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
                    </ng-template>

                    <ng-template #notSaving>
                        <mat-icon>save</mat-icon>
                        <span>{{ 'common.save' | translate }}</span>
                    </ng-template>

                    <button data-test="B-Speichern" mat-flat-button
                            color="accent"
                            [disabled]="(bcmSettingsFacade.isUpdating$ | async) || !formGroup.dirty"
                            (click)="$event.stopPropagation(); save($event)">
                        <ng-container
                                *ngIf="(bcmSettingsFacade.isUpdating$ | async); then saving else notSaving"></ng-container>
                    </button>

                </div>

                <mat-divider class="my-24"></mat-divider>

                <div class="p-16">

                    <div fxLayout="row wrap"
                         fxLayout.lt-sm="column"
                         fxLayoutGap="16px grid"
                         fxLayoutGap.lt-sm="0px">

                        <div fxFlex="100">
                            <h2>
                                {{ 'settings.uiSettings.bookingDialog' | translate }}
                            </h2>
                        </div>

                        <div fxFlex="60" fxFlexAlign="center">
                            <h4>
                                {{ 'settings.uiSettings.bookingLayoutQuestion' | translate }}
                            </h4>
                        </div>

                        <mat-form-field appearance="outline" fxFlex="40">
                            <mat-select formControlName="bookingDialogAppearance">
                                <mat-option [value]="BookingDialogAppearance.ACCORDION">{{ 'settings.uiSettings.bookingLayoutAccordion' | translate }}</mat-option>
                                <mat-option [value]="BookingDialogAppearance.TABS">{{ 'settings.uiSettings.bookingLayoutTabs' | translate }}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <div fxFlex="60" fxFlexAlign="center">
                            <h4>
                                {{ 'settings.uiSettings.bookingFirstChoiceQuestion' | translate }}
                            </h4>
                        </div>

                        <mat-form-field appearance="outline" fxFlex="40">
                            <mat-select formControlName="bookingDialogFirstChoice">
                                <mat-option [value]="BookingDialogFirstChoice.BOAT">{{ 'settings.uiSettings.firstChoiceBoat' | translate }}</mat-option>
                                <mat-option [value]="BookingDialogFirstChoice.PERSON_OR_COMPANY">{{ 'settings.uiSettings.firstChoicePersonOrCompany' | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                    </div>

                </div>
            </div>
        </form>
    </ng-container>
</div>
